import { createAsyncThunk } from '@reduxjs/toolkit';
import type { MetricasEntrega } from '../../types/metricasNotificacoes';
import { notificacoesMetricasService, type NotificacoesMetricasParams } from './services';

export const fetchNotificacoesMetricas = createAsyncThunk<
  MetricasEntrega,
  NotificacoesMetricasParams | undefined,
  { rejectValue: string }
>('notificacoesMetricas/fetch', async (params, { rejectWithValue }) => {
  try {
    return await notificacoesMetricasService.get(params);
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : 'Erro ao carregar métricas de entrega',
    );
  }
});
